'use strict';

/** Import frontoffice_app */
import '../frontoffice_app';

/** Import LocationHandler class */
import LocationHandler from '../../../shared/utility/location_handler/location_handler'

/** Import Cart class */
import Cart from '../../../shared/cart/cart'

// /** Import AjaxHandler class */
// import AjaxHandler from '../../../shared/utility/ajax_handler/ajax_handler'

/** Import APP_CONST */
import APP_CONST from '../../../const';

/**
 * @class CartHandler
 */
class CartHandler
{
    /**
     * @constructor
     */
    constructor ()
    {
        this._renderCartList();
        Cart.addRemoveCallback(this._renderCartList);
    }

    /**
     * @private
     */
    _renderCartList ()
    {
        let
            that = this,
            total = 0,
            cartTotal = 0,
            deliveryTotal = 0,
            cart = Cart.getCartItems(),
            cartList = '',
            imgPrefix = this.constructor._getImgPrefix();

        $.each(cart, (k, v) =>
        {
            let displayPrice = parseInt(v.price);
            if (APP_CONST.HIDDEN_DELIVERY === 'true')
            {
                displayPrice = displayPrice + parseInt(v.delivery_price);
            }

            cartList += '<tr class="cart-item" data-cartitem="' + v.slug + '|' + v.name +'|' + v.price + '|' + v.delivery_price + '|' + v.img + '|' + v.stock + '">' +
                '<td class="product-thumbnail" data-title="Slika"><a href="#"><img class="cart-image" src="' + imgPrefix + v.img + '" alt="img"/></a></td>' +
                '<td class="product-name" data-title="Naziv proizvoda"><a href="' + imgPrefix + 'index.php/product/' + v.slug + '/details' + '">' + v.name + '</a></td>' +
                '<td class="product-price" data-title="Cena"><span class="price">' + displayPrice + ' RSD</span></td>' +
                '<td class="product-quantity" data-title="Kolicina"><div class="quantity">' +
                '<a href="#" class="sign minus item-list-quantity-minus"><i class="fa fa-angle-left"></i></a>' +
                '<input type="text" value="' + v.quantity + '" title="Qty" class="input-text qty text item-list-quantity" size="' + v.quantity + '">' +
                '<a href="#" class="sign plus item-list-quantity-plus"><i class="fa fa-angle-right"></i></a>' +
                '</div></td>' +
                '<td class="product-subtotal" data-title="Ukupno"><span class="price item-list-price-total">' + (displayPrice * v.quantity) + ' RSD</span></td>' +
                '<td class="product-remove"> <a href="#" class="remove"><i class="fa fa-times item-list-remove"></i></a></td>' +
                '</tr>';

            cartTotal = cartTotal + (v.price * v.quantity);
            deliveryTotal = deliveryTotal + (parseInt(v.delivery_price) * v.quantity);
        });

        total = parseInt(cartTotal);
        if (APP_CONST.HIDDEN_DELIVERY === 'true')
        {
            total = parseInt(cartTotal) + parseInt(deliveryTotal);
        }

        $('#cart-item-list-table').empty().html(cartList);
        $('#item-list-total').empty().html(total + ' RSD');

        let
            retailTotal = 0,
            calculateDeliveryTotal = 0,
            sum = 0
        ;

        if (cart.length > 0)
        {
            retailTotal = parseInt(cartTotal);
            calculateDeliveryTotal = parseInt(deliveryTotal);
            sum = retailTotal + calculateDeliveryTotal;

            $('#item-list-retail-total').val(retailTotal);

            if (APP_CONST.HIDDEN_DELIVERY === 'true')
            {
                $('#item-list-delivery').val(calculateDeliveryTotal);
                $('#item-list-delivery-total').val(sum);
            } else {
                calculateDeliveryTotal = calculateDeliveryTotal + ' RSD';
                sum = sum + ' RSD';

                $('#item-list-delivery').html(calculateDeliveryTotal);
                $('#item-list-delivery-total').html(sum);
            }

            Cart.adjustDeliveryTotal(retailTotal, parseInt(deliveryTotal), (retailTotal + parseInt(deliveryTotal)));

            $('#cart-continue').removeAttr('style');
            $('#cart-order').removeAttr('style');

        } else {

            $('#item-list-retail-total').val(retailTotal);

            if (APP_CONST.HIDDEN_DELIVERY === 'true')
            {
                $('#item-list-delivery').val(calculateDeliveryTotal);
                $('#item-list-delivery-total').val(sum);
            } else {
                calculateDeliveryTotal = calculateDeliveryTotal + ' RSD';
                sum = sum + ' RSD';

                $('#item-list-delivery').html(calculateDeliveryTotal);
                $('#item-list-delivery-total').html(sum);
            }

            Cart.adjustDeliveryTotal(0, 0, 0);

            $('#cart-continue').attr('style', 'color: #FFF; cursor: not-allowed; opacity: 0.5; text-decoration: none;');
            $('#cart-order').attr('style', 'color: currentColor; cursor: not-allowed; opacity: 0.5; text-decoration: none;');
        }

        // if (cart.length > 0)
        // {
        //     AjaxHandler.post('delivery-price', cart).then((response) =>
        //     {
        //         let
        //             delivery = parseInt(response.deliveryPrice),
        //             total = delivery + cartTotal;
        //
        //         $('#item-list-delivery').html(delivery + ' RSD');
        //         $('#item-list-delivery-total').html(total + ' RSD');
        //         Cart.adjustDeliveryTotal(cartTotal, delivery, total);
        //
        //         $('#cart-continue').removeAttr('style');
        //         $('#cart-order').removeAttr('style');
        //     });
        // } else {
        //     $('#item-list-delivery').html('0 RSD');
        //     $('#item-list-delivery-total').html('0 RSD');
        //     Cart.adjustDeliveryTotal(0, 0, 0);
        //
        //     $('#cart-continue').attr('style', 'color: #FFF; cursor: not-allowed; opacity: 0.5; text-decoration: none;');
        //     $('#cart-order').attr('style', 'color: currentColor; cursor: not-allowed; opacity: 0.5; text-decoration: none;');
        // }

        $('.item-list-quantity-minus').unbind('click').on('click', (e) =>
        {
            let
                row = that.constructor._findFormRow(e.target),
                cartItem = row.data('cartitem'),
                quantity = row.find('.item-list-quantity').val(),
                itemObj = that._prepareObject(cartItem)
            ;

            quantity = (parseInt(quantity) > 0) ? parseInt(quantity) - 1 : 0;

            Cart.adjustQuantity(itemObj.slug + '', quantity);
            that._renderCartList();
        });

        $('.item-list-quantity-plus').unbind('click').on('click', (e) =>
        {
            let
                row = that.constructor._findFormRow(e.target),
                cartItem = row.data('cartitem'),
                quantity = row.find('.item-list-quantity').val(),
                itemObj = that._prepareObject(cartItem)
            ;

            quantity = parseInt(quantity) + 1;

            Cart.adjustQuantity(itemObj.slug + '', quantity);
            that._renderCartList();
        });

        $('.item-list-quantity').unbind('blur').on('blur', (e) =>
        {
            let
                row = that.constructor._findFormRow(e.target),
                cartItem = row.data('cartitem'),
                quantity = row.find('.item-list-quantity').val(),
                itemObj = that._prepareObject(cartItem)
            ;

            quantity = (quantity) ? parseInt(quantity) : 0;

            if (quantity > parseInt(itemObj.stock))
            {
                quantity = parseInt(itemObj.stock);
            }

            Cart.adjustQuantity(itemObj.slug + '', quantity);
            that._renderCartList();
        });

        $('.item-list-remove').unbind('click').on('click', (e) =>
        {
            let
                row = that.constructor._findFormRow(e.target),
                cartItem = row.data('cartitem'),
                itemObj = that._prepareObject(cartItem);

            Cart.removeFromCartList(itemObj.slug + '');
            that._renderCartList();
        })
    }

    /**
     * @param item
     * @return {*}
     * @private
     */
    _prepareObject(item)
    {
        let
            itemObj = {},
            itemProps = ['slug','name','price','delivery_price','img','stock','quantity'],
            itemData = item.split('|');

        $.each(itemProps, (k,v) =>
        {
            let data = itemData[k];
            if (v === 'quantity')
            {
                data = 1;
            }
            itemObj[v] = data;
        });
        return itemObj;
    }

    /**
     * @param element
     * @returns {jQuery|HTMLElement}
     * @private
     */
    static _findFormRow (element)
    {
        let elem = element;
        while ($(elem).prop("tagName") !== 'TR')
        {
            elem = elem.parentNode;
        }
        return $(elem);
    }

    /**
     * @return {string}
     * @private
     */
    static _getImgPrefix ()
    {
        let base = LocationHandler.getBaseUrl(), index = 'index.php';
        return base.substr(0, (base.length - index.length));
    }
}

/** Start CartHandler */
$(document).ready(() => { new CartHandler(); });


// WEBPACK FOOTER //
// ./assets/js/components/frontoffice/pages/cart.js